module.exports = __webpack_public_path__ + "static/media/manzate_super.fa3b378e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/preventiva/manzate_super.png
// module id = 2116
// module chunks = 3